module.exports = __webpack_public_path__ + "site/img/224.dee84dc5.jpg";